import { Emotion } from "../../../../../types/enum/Emotion"

const NORMAL_EMOTE_PREFIX = "__NORMAL_EMOTE__:"

export function encodeChatEmote(emotion: Emotion, shiny: boolean): string {
  return shiny ? emotion : `${NORMAL_EMOTE_PREFIX}${emotion}`
}

export function decodeChatEmote(payload: string): {
  emotion: Emotion
  forceNormal: boolean
} | null {
  const forceNormal = payload.startsWith(NORMAL_EMOTE_PREFIX)
  const value = forceNormal
    ? payload.slice(NORMAL_EMOTE_PREFIX.length)
    : payload
  if (!Object.values(Emotion).includes(value as Emotion)) return null
  return { emotion: value as Emotion, forceNormal }
}
